export const DEFAULT_SERVER_ERROR = 'There is an error with the server';
export const TERMS_SERVER_URL =
  process.env.TERMS_SERVER_URL || 'http://localhost:8000';

export const ROUTES = {
  HOME: '/',
  REGISTER: '/register',
  REGISTER_STEP_TWO: '/registersteptwo',
  CONFIDENTIALITY: '/privacy',
  TERMSCONDITIONS: '/termsConditions',
  LOGIN: '/login',
  REGISTEREND: '/registerend',
  GLOGIN: '/glogin',
  RELOGIN: '/relogin',
  LOGOUT: '/logout',
  CONFIRM_EMAIL: '/confirm-email',
  RESET_PASSWORD: '/reset-password',
  CHANGE_PASSWORD: '/change-password',
  MAGIC_CODE: '/magic-code',
  SANDBOX: '/sandbox',
  DASHBOARD: '/dev',
  DASHBOARD_IMPLEMENTATION: '/dev/implementation',
  DASHBOARD_INTEGRATION: '/dev/integration',
  DASHBOARD_DOCUMENTATION: '/dev/documentation',
  DASHBOARD_INTEGRATION_ADD_PRODUCT: '/dev/integration/addproduct',
  DASHBOARD_INTEGRATION_LIST_PRODUCT: '/dev/integration/listproducts',
  DASHBOARD_INTEGRATION_DETAILS_PRODUCT: '/dev/integration/detailsproduct',
  DASHBOARD_BNPL: '/bnpl/providers',
  DASHBOARD_ONEY_SETTINGS: '/bnpl/oney',
  DASHBOARD_PAYPO_SETTINGS: '/bnpl/paypo',
  POS_SETTINGS_NOTIFICATIONS: '/pos/settings/notifications',
  LIST_USERS: '/listusers',
  USER_DETAILS: '/userdetails',
  REGISTER_COMPANY: '/register-company',
  SUPPORT: '/support',
  PROFILE: '/profile',
  COMPANY_PROFILE: '/company-profile',
  MESSAGES: '/messages',
  MESSAGES_FORM: '/message-form',
  COMPANY_STATUS: '/company-status',
  DOMAINS: '/domains',
  POS_SETTINGS: '/possettings',
  LIST: '/list',
  CARD: '/card',
  BNPL_ORDER_LIST: '/bnpl/orders',
  GDPR: '/gdpr',
  FACTORING: '/factoring',
  BUSINESSCARD: '/businesscard',
  MEDIAKIT: '/mediakit',
  CRYPTO_CURRENCY: '/crypto',
  BANK_TRANSFER: '/banktr',
  SMS_ONLINE: '/smson',
  SMS_OFFLINE: '/smsoff',
  SMS_RECURRENCE: '/smsrec',
  CASH: '/cash',
  USERS: '/users',
  ORDER_LIST: '/orders',
  ORDER_DETAILS: '/orderdetails',
  TRANSACTION_DASHBOARD: '/dashboard',
  CHARGEBACK_STATUS: '/chargebackstatus',
  POS: '/pos',
  TERMS: '/terms',
  LEGAL: '/legal',
  // KYB: '/kyb',
  KYBDOMAINS: '/kybdomains',
  KYC: '/kyc',
  KYCDOMAINS: '/kycdomains',
  // CONTACT: '/contact',
  DETAILS: '/details',
  REPORTS: '/reports',
  REPORTS_CUSTOM: '/reports/custom',
  REPORTS_CUSTOM_DOWNLOAD: '/reports/custom/download',
  REPORTS_BANKTRANSFER: '/reports/banktransfer',
  REPORTS_BANKTRANSFER_DOWNLOAD: '/reports/banktransfer/download',
  INBOX: '/inbox',
  LIVE: '/live',
  TRANSFERS: '/transfers',
  TRANSFER_DETAILS: '/transferdetails',
  TRANSFER_SUMMARY: '/transfersummary',
  ISSUED_INVOICES: '/issuedinvoices',
  SMS_INVOICES: '/smsinvoices',
  INVOICES: '/invoices',
  EXPORTS: '/exports',
  XSESSION: '/crosslogin',
  SECURITY: '/security',
  TESTPAGE: '/testpage',
  DASHBOARD_LINK2PAY: '/dev/link2pay',
  SERVICE_UNAVAILABLE: '/service-unavailable',
};
